<template>
  <div class="l-content-inner">
    <!-- 약관동의 -->
    <TermsCondition v-if="data.step1" />
    <!-- 정보입력 -->
    <InfoInput v-if="data.step2" />
    <!-- 가입완료 -->
    <RegistComplete v-if="data.step3" />
    <!-- 아이디찾기 -->
    <IdFind v-if="data.step4" />
    <!-- 아이디찾기 완료 -->
    <IdFindComplete v-if="data.step5" />
    <!-- 패스워드찾기 -->
    <PwFind v-if="data.step6" />
    <!-- 패스워드찾기 완료 -->
    <PwFindComplete v-if="data.step7" />
    <!-- 아이디찾기 -->
    <PwFindCompleteLayer v-if="data.step8" />
  </div>
</template>
<script setup name="member_index">
import { reactive } from "vue";

import TermsCondition from "@/components/paintpro/member/termsCondition.vue";
import InfoInput from "@/components/paintpro/member/infoInput.vue";
import RegistComplete from "@/components/paintpro/member/registComplete.vue";
import IdFind from "@/components/paintpro/member/idFind.vue";
import IdFindComplete from "@/components/paintpro/member/idFindComplete.vue";
import PwFind from "@/components/paintpro/member/pwFind.vue";
import PwFindComplete from "@/components/paintpro/member/pwFindComplete.vue";
import PwFindCompleteLayer from "@/components/paintpro/member/pwFindCompleteLayer.vue";

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  step1: true,
  step2: false,
  step3: false,
  step4: false,
  step5: false,
  step6: false,
  step7: false,
});
</script>
